import qs from 'qs';
import Util from '@/util';

const QuestionProperty = {
    namespaced: true,

    state: {
        questionPropertyData: [],
        propertyListByQuestionDataType: [],
    },

    getters: {
        questionPropertyData(state) {
            return state.questionPropertyData;
        },

        propertyListByQuestionDataType(state) {
            return state.propertyListByQuestionDataType;
        },
    },

    mutations: {
        /**
         * Установить значение массива
         * @param state
         * @param nameArr Название массива из state
         * @param items
         */
        setArr(state, { nameArr, items }) {
            state[nameArr] = items;
        },

        /**
         * Обновить значение элемента "вопрос - свойство"
         * Обновлению подлежат только значения propertyValue и isActive
         * @param state
         * @param item
         * @param compositeIndex
         */
        setItem(state, { item, compositeIndex }) {
            // Определяем элемент, подлежащий редактированию, по составному индексу
            let editableItem = state['questionPropertyData'].find((el) => {
                return el.questionId === compositeIndex.questionIdForCompositeIndex && el.propertyId === compositeIndex.propertyIdForCompositeIndex;
            });

            // Присваиваем редактируемому элементу новые значения propertyValue и isActive
            editableItem.propertyValue = item.propertyValue;
            editableItem.isActive = item.isActive;
        },

        /**
         * Добавить в массив связей "вопрос - свойство" новый элемент 
         * @param state
         * @param item
         */
        addItem(state, { item }) {
            state['questionPropertyData'].push(item);
        },

        /**
         * Удалить элемент из массива связей "вопрос - свойство"
         * @param state
         * @param item
         */
        remove(state, { item }) {
            state['questionPropertyData'] = state['questionPropertyData'].filter((el) => el.propertyId !== item.propertyId);
        },
    },


    actions: {
        /**
         * Получение данных по связям "вопрос - свойство"
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @param requestParameters Параметры GET-запроса
         * @returns {Promise<any>}
         */
        getQuestionPropertyListByQuestionId({ commit, dispatch, getters, rootGetters }, requestParameters) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'requestParameters': Util.buildGetParams(requestParameters),
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.questionPropertyByQuestionId,
                    }),
                }).then(response => (
                    commit('setArr', {
                        nameArr: 'questionPropertyData',
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по связям "вопрос - свойство" получены.'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN questionProperty.js | getQuestionPropertyListByQuestionId: ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по связям "вопрос - свойство"!'),
                    reject(err);
                });
            })
        },

        /**
         * Получение данных по свойствам
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @param requestParameters Параметры GET-запроса
         * @returns {Promise<any>}
         */
         getPropertyListByQuestionDataType({ commit, dispatch, getters, rootGetters }, requestParameters) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'requestParameters': Util.buildGetParams(requestParameters),
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.propertyByDataType,
                    }),
                }).then(response => (
                    commit('setArr', {
                        nameArr: 'propertyListByQuestionDataType',
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по свойствам получены.'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN property.js | getPropertyListByQuestionDataType: ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по свойствам!'),
                    reject(err);
                });
            })
        },

        /**
         * Сохранение данных по связям "вопрос - свойство"
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveQuestionPropertyData({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                
                const str = JSON.stringify(data.data);

                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.questionProperty,
                    }),
                }).then(response => {
                    // Если редактирование
                    if (data.compositeIndex.propertyIdForCompositeIndex !== null) {
                        commit('setItem', {
                            item: data.data,
                            compositeIndex: data.compositeIndex
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по связям "вопрос - свойство" успешно отредактированы!');
                    // Если сохранение нового
                    } else {
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новая связь "вопрос - свойство" успешно создана!');
                    }
                    resolve(response);
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN questionProperty.js | saveQuestionPropertyData: ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление связи "вопрос - свойство"
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeQuestionPropertyData({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify(data.item);

                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.questionProperty,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Связь "вопрос - свойство" успешно удалена!'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении связи "вопрос - свойство"!'),
                    console.log('ERROR IN questionProperty.js | removeQuestionPropertyData: ' + err);
                    reject(err);
                });
            })
        }
    },
};

export default QuestionProperty;


// WEBPACK FOOTER //
// ./src/store/modules/questionProperty.js